import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { api } from "../../environments/environment";
import { LoaderService } from "../service/loader.service";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";

@Component({
  selector: "app-complete",
  templateUrl: "./complete.component.html",
  styles: [],
  standalone: false,
})
export class CompleteComponent implements OnInit {
  constructor(
    private router: Router,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService
  ) { }
  step = 1
  completeData: any = {
    // fatturatiUltimiTreAnni: [{}, {}, {}],
    // sedi: [],
    // ateco:[]
  }

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    let user = JSON.parse(localStorage.getItem('user') ?? '')
    if (user?.completed) {
      window.location.replace('profilo')
    }
  }

  removeSede(index: number) {
  }

  removeAteco(index: number) {
  }

  sedeType(value: any, index: number) {
    this.completeData.sedi[index].tipo = value.element
  }

  atecoType(value: any, index: number) {
    this.completeData.ateco[index].tipo = value.element
  }

  confirmData() {
    let user = JSON.parse(localStorage.getItem('user') ?? '')
    if (user?.completed) {
      window.location.replace('profilo')
    } else {
      this.completeData.numeroDipendenti = parseInt(this.completeData.numeroDipendenti)
      this.loader.on()
      this.rest.post('/profile/complete', this.completeData).subscribe({
        next: (value: any) => {
          user.role = this.completeData.role
          user.completed = true
          localStorage.setItem('user', JSON.stringify(user))
          this.loader.off(true)
          if (this.completeData.role == 1 || this.completeData.role == 5) {
            this.router.navigate(['progetti'])
          } else {
            this.router.navigate(['piani'])
          }

        },
        error: (value: any) => {
          this.loader.off(true)
        },
      })
    }
  }

}
